import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { UniDriverFactory } from '@wix/wix-ui-test-utils/uni-driver-factory';

export interface TableListItemUniDriver extends BaseUniDriver {
  getColumnTextAt(columnIndex: number): Promise<string>;
  isCheckboxExists(): Promise<boolean>;
  isCheckboxChecked(): Promise<boolean>;
  isCheckboxDisabled(): Promise<boolean>;
  toggleCheckbox(): Promise<void>;
  getDragHandleDisabled(): Promise<boolean>;
  expandHandleExists(): Promise<boolean>;
  toggleExpandHandle(): Promise<void>;
}

declare const tableListItemDriverFactory: UniDriverFactory<TableListItemUniDriver>;
